import { render, staticRenderFns } from "./sts.vue?vue&type=template&id=35ddeadc&"
import script from "./sts.vue?vue&type=script&lang=js&"
export * from "./sts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports